module.exports = __webpack_public_path__ + "img/system_audit_trail.aacf9628.svg";